import { useNavigateWithSearchParams } from "@p0security/frontend-core";
import { AppPaths } from "@p0security/shared/routes/constants";
import { Button } from "@p0security/ui";
import React, { useCallback } from "react";
import { useParams } from "react-router";

const SkipOnboardingButton = React.memo(
  ({ textOverride }: { textOverride?: string }) => {
    const navigateWithSearchParams = useNavigateWithSearchParams();
    const { orgSlug } = useParams();

    const handleSkip = useCallback(() => {
      navigateWithSearchParams(`/o/${orgSlug}/${AppPaths.Dashboard}`);
    }, [navigateWithSearchParams, orgSlug]);

    return (
      <Button type="link" onClick={handleSkip} className="p-0">
        {textOverride || "Skip onboarding"}
      </Button>
    );
  }
);

SkipOnboardingButton.displayName = "SkipOnboardingButton";

export { SkipOnboardingButton };
